import { createApiHooks } from '@apis/next/common';
import { InvoiceLog } from '@models/next/InvoiceLog';
import { z } from 'zod';

export const dashboardInvoiceLogApis = createApiHooks('/dashboard/invoice-log', [
  {
    method: 'get',
    path: '/:id',
    parameters: [
      {
        type: 'Path',
        name: 'id',
        schema: z.number(),
      },
    ],
    response: InvoiceLog.array(),
  },
]);
